import { SAVE, SAVE_SUCCESS, SAVE_FAILED, RESET_DIALOG } from './constants';

export const saveAction = (data) => ({
  type: SAVE,
  data,
});
export const saveSuccessAction = (emailVerificationRequested) => ({
  type: SAVE_SUCCESS,
  emailVerificationRequested,
});
export const saveFailedAction = (
  error,
  errorCode,
  errorMsg,
  duplicateNonprofitId,
  duplicateNonprofitName
) => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  errorMsg,
  duplicateNonprofitId,
  duplicateNonprofitName,
});

export const resetDialogAction = () => ({ type: RESET_DIALOG });
